import { createApi } from "@reduxjs/toolkit/query/react";
import * as config from "config";
import * as utils from "utils";

const baseQuery = async (args, api, extraOptions) => {
  try {
    const fetch = args.noRetry
      ? utils.authenticatedFetchNoRetry
      : utils.authenticatedFetch;
    const response = await fetch(
      config.endpoints.materialize(args.url),
      args.payload || {},
      args.impersonateCompanyId
    );
    return {
      data: await response.json(),
    };
  } catch (error) {
    return { error };
  }
};

export const materializeApi = createApi({
  reducerPath: "materializeApi",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    retrieveCacheStatistics: builder.query({
      query: (args) => ({
        url: "/named-query-cache-statistics",
        payload: {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        },
        impersonateCompanyId: args.impersonateCompanyId,
      }),
    }),
    refreshCaches: builder.mutation({
      query: ({ queryName, impersonateCompanyId }) => ({
        url: "/refresh-named-query-cache",
        payload: {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ queryName }),
        },
        impersonateCompanyId,
      }),
    }),
    getCompanySubmissionCacheStats: builder.query({
      query: (companyId) => ({
        url: `/company-submission-cache-stats/${companyId}`,
      }),
    }),
    triggerMaterialization: builder.mutation({
      query: ({ companyId }) => ({
        url: "/trigger-materialization",
        noRetry: true,
        payload: {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ companyId }),
        },
      }),
    }),
    triggerCreateTable: builder.mutation({
      query: ({ companyId }) => ({
        url: "/trigger-create-table",
        payload: {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ companyId }),
        },
      }),
    }),
  }),
});

export const {
  useRetrieveCacheStatisticsQuery,
  useRefreshCachesMutation,
  useGetCompanySubmissionCacheStatsQuery,
  useTriggerMaterializationMutation,
  useTriggerCreateTableMutation,
} = materializeApi;
